import HealthBadge from "../../../components/Badges/HealthBadge";
import SurveyBadge from "../../../components/Badges/SurveyBadge";
import { useTranslation } from "react-i18next";

const ResultInfoModalExpant = (props: { id?: number }) => {
  const translation = useTranslation();
  const { t, i18n } = translation;
  const lang = i18n.language;
  
  return (
    <div>
      {props.id === 1 ? (
        // Self-assessment and feedback
        <div>
          <div className="text-sm">{t("self-assessment-and-feedback-description")}</div>
          <div className="mt-2">
            {/* Excellent */}
            <SurveyBadge value={0.89} type="score" lang={lang} />
            <div className="text-xs mt-1 text-gray-300">
             {t("self-assessment-and-feedback-excellent-note")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700" />
          {/* High */}
          <div className="mt-2">
            <SurveyBadge value={0.77} type="score" lang={lang} />
            <div className="text-xs mt-1 text-gray-300">
              {t("self-assessment-and-feedback-high-note")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700" />
          {/* Moderate */}
          <div className="mt-2">
            <SurveyBadge value={0.61} type="score" lang={lang} />
            <div className="text-xs mt-1 text-gray-300">
             {t("self-assessment-and-feedback-moderate-note")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700" />
          {/* Low */}
          <div className="mt-2">
            <SurveyBadge value={0.5} type="score" lang={lang} />
            <div className="text-xs mt-1 text-gray-300">{t("self-assessment-and-feedback-low-note")}</div>
          </div>
        </div>
      ) : props.id === 2 ? (
        // Perception gap
        <div>
          <div className="text-sm">{t("perception-gap-description-description")}</div>
          <div className="mt-2">
            {/* Healthy */}
            <SurveyBadge value={0} type="gap" lang={lang}/>
            <div className="text-xs mt-1 text-gray-300">
              {t("perception-gap-description-healthy")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700"/>
          {/* Balanced */}
          <div className="mt-2">
            <SurveyBadge value={0.5} type="gap" lang={lang}/>
            <div className="text-xs mt-1 text-gray-300">{t("perception-gap-description-balanced")}</div>
          </div>
          <hr className="my-2 border-indigo-700"/>
          {/* Moderate */}
          <div className="mt-2">
            <SurveyBadge value={0.9} type="gap" lang={lang}/>
            <div className="text-xs mt-1 text-gray-300">
              {t("perception-gap-description-moderate")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700"/>
          {/* Significan */}
          <div className="mt-2">
            <SurveyBadge value={1.3} type="gap" lang={lang}/>
            <div className="text-xs mt-1 text-gray-300">{t("perception-gap-description-significan")}</div>
          </div>
        </div>
      ) : props.id === 3 ? (
        // Feedback alignment
        <div>
          {/* Feedback alignment */}
          <div className="text-sm">{t("feedback-alignment-description")}</div>
          {/* Healthy */}
          <div className="mt-2">
            <SurveyBadge value={0.76} type="feedback_alignment" lang={lang}/>
            <div className="text-xs mt-1 text-gray-300">
              {t("feedback-alignment-healthy")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700"/>
          {/* Balanced */}
          <div className="mt-2">
            <SurveyBadge value={0.51} type="feedback_alignment" lang={lang}/>
            <div className="text-xs mt-1 text-gray-300">
              {t("feedback-alignment-balanced")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700"/>
          {/* Moderate */}
          <div className="mt-2">
            <SurveyBadge value={0.26} type="feedback_alignment" lang={lang}/>
            <div className="text-xs mt-1 text-gray-300">
              {t("feedback-alignment-moderate")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700"/>
          {/* Low */}
          <div className="mt-2">
            <SurveyBadge value={0.0} type="feedback_alignment" lang={lang}/>
            <div className="text-xs mt-1 text-gray-300">{t("feedback-alignment-low")}</div>
          </div>
        </div>
      ) : props.id === 4 ? (
        // Focus Area Health
        <div>
          <div className="text-sm">{t("focus-area-health-description")}</div>
          {/* Excellent */}
          <div className="mt-2">
          <HealthBadge value={0.9} lang={lang} isResultInfoModal={true} />
            <div className="text-xs mt-1 text-gray-300">
              {t("focus-area-health-excellent")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700" />
          {/* Good */}
          <div className="mt-2">
            <HealthBadge value={0.75} lang={lang} isResultInfoModal={true} />
            <div className="text-xs mt-1 text-gray-300">
              {t("focus-area-health-good")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700" />
          {/* Moderate */}
          <div className="mt-2">
            <HealthBadge value={0.55} lang={lang} isResultInfoModal={true} />
            <div className="text-xs mt-1 text-gray-300">
              {t("focus-area-health-moderate")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700" />
          {/* Poor */}
          <div className="mt-2">
            <HealthBadge value={0.0} lang={lang} isResultInfoModal={true} />
            <div className="text-xs mt-1 text-gray-300">
              {t("focus-area-health-poor")}
            </div>
          </div>
        </div>
      ) : (
        // Assessment question interpretation
        <div>
          <div className="text-sm">{t("assessment-question-interpretation-description")}</div>
          <div className="mt-2">
            {/* Validated strength */}
            <SurveyBadge value={4} type="validated" lang={lang} value2={4}/>
            <div className="text-xs mt-1 text-gray-300">
              {t("assessment-question-interpretation-validated-strength")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700"/>
          {/* Hidden strength */}
          <div className="mt-2">
            <SurveyBadge value={3} type="validated" lang={lang} value2={4}/>
            <div className="text-xs mt-1 text-gray-300">
              {t("assessment-question-interpretation-hidden-strength")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700"/>
          {/* Blind spot */}
          <div className="mt-2">
            <SurveyBadge value={4} type="validated" lang={lang} value2={3}/>
            <div className="text-xs mt-1 text-gray-300">
              {t("assessment-question-interpretation-blind-spot")}
            </div>
          </div>
          <hr className="my-2 border-indigo-700"/>
          {/* Growth priority */}
          <div className="mt-2">
            <SurveyBadge value={3} type="validated" lang={lang} value2={3}/>
            <div className="text-xs mt-1 text-gray-300">
              {t("assessment-question-interpretation-growth-priority")}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResultInfoModalExpant;
